var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType ==='desktop')?_c('blog-desktop'):_c('blog-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }